export default __webpack_public_path__ + "static/media/remarketing.c05d9067.svg";